export const selectShops = state => state.shop.shops;
export const selectProducts = state => state.shop.products;
export const selectIsLoading = state => state.shop.isLoading;
export const selectFilter = state => state.shop.filter